import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { STATUS_LABELS, formatDateShortIT } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import StatusBadge from "@/components/app/StatusBadge";
import { Boxes, Search } from "lucide-react";

export default function RepairsList() {
  const [cases, setCases] = useState([]);
  const [q, setQ] = useState("");

  const load = async (query = "") => {
    const r = await api.get(`/repairs/cases${query ? `?q=${encodeURIComponent(query)}` : ""}`);
    setCases(r.data);
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto" data-testid="repairs-list-page">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
        <div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-[#0a0a2e]">Pratiche di assistenza</h1>
          <p className="text-slate-500">Cerca per numero pratica, cliente, codice cliente.</p>
        </div>
        <div className="flex gap-2 w-full md:w-96">
          <div className="relative flex-1">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input data-testid="repairs-search" className="pl-9" placeholder="AMA-RMA-… o ragione sociale" value={q} onChange={(e) => setQ(e.target.value)} />
          </div>
          <Button onClick={() => load(q)} className="ama-btn-primary">Cerca</Button>
        </div>
      </div>

      <div className="grid gap-3">
        {cases.length === 0 && <div className="ama-card p-8 text-center text-slate-500">Nessuna pratica trovata.</div>}
        {cases.map((c) => (
          <Link key={c.id} to={`/pratiche/${c.id}`} className="ama-card p-4 hover:border-[#d63384] transition-colors" data-testid={`case-row-${c.case_number}`}>
            <div className="flex flex-col md:flex-row md:items-center gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <div className="font-heading font-bold text-[#0a0a2e]">{c.case_number}</div>
                  <StatusBadge status={c.status === "chiusa" ? "Chiuso" : "Ricevuto_da_AMA"} />
                  <span className="text-xs text-slate-500">· {formatDateShortIT(c.created_at)}</span>
                </div>
                <div className="text-sm text-slate-700 mt-1">{c.customer_snapshot?.company_name} — {c.delivering_person}</div>
              </div>
              <div className="flex flex-wrap gap-1">
                {c.items_summary?.map((it) => (
                  <div key={it.item_number} className="inline-flex items-center gap-1 text-xs bg-slate-100 rounded-full px-2 py-1">
                    <Boxes className="w-3 h-3 text-slate-500" />
                    {it.manufacturer_name} · {STATUS_LABELS[it.current_status]}
                  </div>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
